import {useCallback, useEffect} from 'react'

const useOnPressKey = (callback, keyCode) => {
  const closeOnEsc = useCallback(
    event => {
      if (callback && event.keyCode === keyCode) {
        callback()
      }
    },
    [callback],
  )

  useEffect(() => {
    document.addEventListener('keydown', closeOnEsc, false)
    return () => {
      document.removeEventListener('keydown', closeOnEsc, false)
    }
  }, [])
}

export default useOnPressKey
